// extracted by mini-css-extract-plugin
export default {"container":"rX-z","title":"sX-z","link":"tX-z"};